import { Author } from './types'

export const Carol: Author = {
  id: 'carol',
  name: 'Carol',
  title: 'Mum of two, writer, & illustrator',
  bio: 'Carol is a passionate educator and writer dedicated to helping parents unlock the magic of reading and storytelling with their children.',
  avatar: '/images/author-carol.webp',
  expertise: [
    'Reading & Literacy',
    'Child Development',
    'Storytelling',
  ],
}

export const Maya: Author = {
  id: 'maya',
  name: 'Maya',
  title: 'Bilingual mum & language teacher',
  bio: 'Maya is a bilingual educator raising trilingual kids in English, Mandarin, and Vietnamese. She writes about multilingual learning, heritage language preservation, and how stories help kids embrace multiple cultures.',
  avatar: '/images/author-maya.webp',
  expertise: [
    'Multilingual Learning',
    'Language Development',
    'Cultural Identity',
  ],
}

export const James: Author = {
  id: 'james',
  name: 'James',
  title: 'Dad of three & ed-tech writer',
  bio: 'James is a software engineer turned stay-at-home dad who is fascinated by how technology can enhance childhood learning without replacing real-world experiences. He reviews AI tools, educational apps, and the tech behind personalized books.',
  avatar: '/images/author-james.webp',
  expertise: [
    'AI & Education',
    'EdTech Reviews',
    'STEM Learning',
  ],
}

export const Sarah: Author = {
  id: 'sarah',
  name: 'Dr. Sarah',
  title: 'Child psychologist & mum',
  bio: 'Dr. Sarah is a child psychologist with 12 years of clinical experience. She translates developmental research into practical advice parents can actually use at home.',
  avatar: '/images/author-sarah.webp',
  credentials: 'Ph.D. in Developmental Psychology',
  expertise: [
    'Child Psychology',
    'Early Literacy',
    'Social-Emotional Development',
  ],
}

const authors: Author[] = [Carol, Maya, James, Sarah]

/**
 * Get author by ID
 */
export const getAuthorById = (id: string): Author | undefined => {
  return authors.find((a) => a.id === id)
}

/**
 * Get all authors
 */
export const getAllAuthors = (): Author[] => {
  return authors
}

/**
 * Get all author IDs
 */
export const getAllAuthorIds = (): string[] => {
  return authors.map((a) => a.id)
}

/**
 * Default author for blog posts
 */
export const getDefaultAuthor = (): Author => {
  return Carol
}
